// ---------------------------------------------------------------------------
// Boundary mapping between SpreadsheetEditor's generic QuoteColumnType and the
// narrower ScheduleColumnType used by the schedule-of-rates feature.
//
// Used by both EditScheduleOfRatesModal (modal editor) and
// CompanyScheduleOfRatesSettings (inline editor) so the two surfaces share
// a single source of truth for type constraints.
// ---------------------------------------------------------------------------

import type { QuoteColumnType } from "../SpreadsheetEditor";
import type { ScheduleColumnType } from "./schedule-of-rates.types";

export const SCHEDULE_TO_QUOTE: Record<ScheduleColumnType, QuoteColumnType> = {
	text: "response_text",
	number: "response_number",
	currency: "response_value",
	unit_of_measurement: "unit_of_measurement",
};

export const QUOTE_TO_SCHEDULE: Partial<
	Record<QuoteColumnType, ScheduleColumnType>
> = {
	response_text: "text",
	response_number: "number",
	response_value: "currency",
	unit_of_measurement: "unit_of_measurement",
};

export const ALLOWED_QUOTE_TYPES = new Set<QuoteColumnType>([
	"response_text",
	"response_number",
	"response_value",
	"unit_of_measurement",
]);

export const quoteToScheduleType = (q: QuoteColumnType): ScheduleColumnType =>
	QUOTE_TO_SCHEDULE[q] ?? "text";

export const scheduleToQuoteType = (s: ScheduleColumnType): QuoteColumnType =>
	SCHEDULE_TO_QUOTE[s];
